import React from 'react';
import PropTypes from 'prop-types';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import messages from '../messages';
import { StatsRow, StatCard, StatLabel, StatValue } from '../styles';

const SummaryStats = ({ assessmentCount, totalItems, isScored }) => (
  <StatsRow>
    <StatCard>
      <StatLabel>{intl.formatMessage(messages.assessments)}</StatLabel>
      <StatValue>{assessmentCount}</StatValue>
    </StatCard>
    <StatCard>
      <StatLabel>{intl.formatMessage(messages.totalItems)}</StatLabel>
      <StatValue>{totalItems}</StatValue>
    </StatCard>
    <StatCard>
      <StatLabel>{intl.formatMessage(messages.scored)}</StatLabel>
      <StatValue>{intl.formatMessage(isScored ? messages.yes : messages.no)}</StatValue>
    </StatCard>
  </StatsRow>
);

SummaryStats.propTypes = {
  assessmentCount: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  isScored: PropTypes.bool,
};

export default SummaryStats;
